class SplideCarousel extends HTMLElement {
    constructor() {
      super();
      
      this.id = this.getAttribute('id');
      this.perPageDesktop = this.dataset.desktopPerPage;
      this.perpageMobile = this.dataset.mobilePerPage;
      this.desktopgap = this.dataset.desktopgap || 15;
      this.gapValue = this.dataset.gap;
      this.tabGap = this.dataset.gaptab;
      this.arrowDesktop = this.dataset.desktoparrow === 'true'? true : false;
      this.arrowMobile = this.dataset.mobilearrow === 'true'? true : false;
      this.paginationDesktop = this.dataset.desktoppagination === 'true'? true : false;
      this.paginationMobile = this.dataset.mobilepagination === 'true'? true : false;
      this.mobilePaddingLeft = this.dataset.mobilePaddingLeft;
      this.mobilePaddingRight = this.dataset.mobilePaddingRight;
      this.desktopPaddingLeft = this.dataset.desktopPaddingLeft;
      this.desktopPaddingRight = this.dataset.desktopPaddingRight;
      this.autoplay = this.dataset.autoplay === 'true'? true : false;
      this.speed = this.dataset.speed;
    }
   
    connectedCallback() {
      new Splide(this, {
        type: 'loop',
        rewind: false,
        rewindSpeed: 3000,
        speed: this.speed,
        start: 0,
        perMove: 1,
        drag: true,
        perPage: this.perPageDesktop,
        gap: `${this.gapValue}px`,
        arrows: this.arrowDesktop,
        pagination: this.paginationDesktop,
        autoplay: this.autoplay,
        interval: 4000,
        padding: { left: this.desktopPaddingLeft, right: this.desktopPaddingRight },
        classes: {
          pagination: 'splide__pagination ibc_pagination',
          page: 'splide__pagination__page ibc_page',
        },
        breakpoints: {
          749: {
            type: 'loop',
            perPage: this.perpageMobile,
            arrows: this.arrowMobile,
            pagination: this.paginationMobile,
            gap: 8,
            padding: { left: this.mobilePaddingLeft, right: this.mobilePaddingRight },
          },
        }
      }).mount();
    }
  }
  
  customElements.define('splide-carousel', SplideCarousel);